module.exports = __webpack_public_path__ + "7486dcd51c34adc47226171f0825be2c.pdf";